<template>
  <b-navbar v-if="getPlantState" toggleable="lg" class="second-navbar-style">
      <router-link pressed="btn_state_overview" class="nav-link" :to="{path: '/plant/'+ this.$store.state.currentPlant.id}">Overview</router-link>
      <router-link pressed="btn_state_devices" class="nav-link" :to="{path: '/plantcentralunits/'+ this.$store.state.currentPlant.id}">Dispositivi</router-link>
  </b-navbar> 
</template>

<script>

import { mapState } from 'vuex';

export default {
  name: 'NavBarMain',
  computed: {
    getPlantState()
    {
      if(this.$store.state.currentPlant!=null)
        return true
      else
        return false
    },
    btn_state_overview() {
           if(this.$router.currentRoute.name=="HomeImpianto") 
            return true
           else
            return false
    },
    btn_state_devices() {
           if(this.$router.currentRoute.name=="Centrali") 
            return true
           else
            return false
    }
  }
}
</script>
